module.exports = __webpack_public_path__ + "img/ico_close_black.868fd354.svg";